<template>
  <footer class="footer">
    <Container>
      <div class="footer__wrapper footer__wrapper--links">
        <ul class="nav-footer" v-if="showLinks">
          <li class="nav-footer__item">
            <router-link :to="localizedLink('home')" class="nav-footer__link">
              <span>{{ $t("implementation") }}</span>
            </router-link>
          </li>
          <li class="nav-footer__item">
            <router-link
              :to="localizedLink('documentation')"
              class="nav-footer__link"
            >
              <span>{{ $t("documentation") }}</span>
            </router-link>
          </li>
          <li class="nav-footer__item">
            <router-link
              :to="localizedLink('datasets')"
              class="nav-footer__link"
            >
              <span>{{ $t("datasets") }}</span>
            </router-link>
          </li>
        </ul>
        <div class="nav-social" v-if="showLinks">
          <div class="nav-social__item">
            <span>{{ $t("share") }}</span>
          </div>
          <div class="nav-social__item">
            <a
              :href="
                'https://www.facebook.com/sharer/sharer.php?u=' +
                  orgConfig('organization.url')
              "
              class="nav-social__link"
            >
              <svgicon name="facebook" />
            </a>
          </div>
          <div class="nav-social__item">
            <a
              :href="
                'https://www.linkedin.com/shareArticle?mini=true&url=' +
                  orgConfig('organization.url') +
                  '&title=' +
                  orgConfig('organization.name')
              "
              class="nav-social__link"
            >
              <svgicon name="linkedin" />
            </a>
          </div>
          <div class="nav-social__item">
            <a
              :href="
                'https://twitter.com/home?status=' +
                  orgConfig('organization.url')
              "
              class="nav-social__link"
            >
              <svgicon name="twitter" />
            </a>
          </div>
        </div>
      </div>
      <div class="footer__wrapper">
        <Dropdown
          :dropdown-is-open="dropdownIsOpen"
          @handleClick="dropdownIsOpen = !dropdownIsOpen"
        />
        <div class="footer__logo">
          <a href="//apitalks.com" target="_blank">
            <img src="@/assets/images/logo-white.svg" alt="" />
          </a>
        </div>
      </div>
    </Container>
  </footer>
</template>

<script>
import Dropdown from "@/components/shared/Dropdown.vue";
import Container from "@/components/homepage/Container";
import { localizedLink, orgConfig } from "@/mixins";

export default {
  mixins: [localizedLink, orgConfig],
  components: {
    Dropdown,
    Container
  },
  props: {
    showLinks: {
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {
      dropdownIsOpen: false
    };
  }
};
</script>

<style lang="scss" scoped>
.footer {
  padding: 10px 0 25px;
  font-size: rem(14);
  background-color: $--color-landing-primary;
  color: $--color-white;
  @media (min-width: $breakpoint-sm) {
    padding: 25px 0;
  }
  * {
    fill: $--color-white;
    stroke: $--color-white;
  }
}

.footer__logo {
  a {
    display: block;
  }

  img {
    display: block;
  }
}

.footer__wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 0;
}

.footer__wrapper--links {
  @media (max-width: $breakpoint-sm - 1) {
    flex-wrap: wrap;
  }
}

.nav-footer {
  margin: 0;
  padding: 0;
  list-style: none;
  @media (max-width: $breakpoint-sm - 1) {
    width: 100%;
    order: 2;
    margin-bottom: 10px;
  }
  @media (min-width: $breakpoint-sm) {
    display: flex;
  }
}

.nav-footer__item {
  display: block;
  @media (max-width: $breakpoint-sm - 1) {
    &:not(:last-child) {
      margin-bottom: 5px;
    }
  }
  @media (min-width: $breakpoint-sm) {
    & + .nav-footer__item {
      margin-left: $--nav-item-spacing-y;
    }
  }
}

.nav-footer__link {
  font-weight: 400;
  color: $--color-white;

  span {
    display: block;
    transition: transform 0.15s ease-in-out;
  }

  &:hover {
    color: $--color-white;
    span {
      transform: translateY(-3px);
    }
  }
}

.nav-social {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-weight: 700;
  @media (max-width: $breakpoint-sm - 1) {
    margin-bottom: 35px;
  }
}

.nav-social__item {
  &:first-child {
    margin-right: 22px;
  }
  & + .nav-social__item:not(:last-child) {
    margin-right: $--nav-item-spacing-y;
  }
}

.nav-social__link {
  .svg-icon {
    display: block;
    width: 20px;
    height: 20px;
    transition: transform 0.15s ease-in-out;
  }

  &:hover .svg-icon {
    transform: translateY(-3px);
  }
}
</style>
